/*
Controller: Analytics

Operations:
  logBannedWords
  getMetrics
*/
var Api = require('../config')
var BannedWordsLogsDef = require('../definitions/BannedWordsLogs')

var Analytics = (function () {
  /*
  Operation: logBannedWords
  Add a new banned word log
  Parameters:

  Responses:
    HTTP 200: OK
  */
  function logBannedWordsAnalytics (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        BannedWordsLogsDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/analytics/banned-words'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getMetrics
  Fetch metrics data
  Parameters:
    scope: Defines the context or range of the metric (e.g., foundry, promotion, user)
    metricType: Specifies the type of metric being recorded (e.g., yearlyPromoCount, userCount)
    entityId: Stores the ID of the related entity (e.g., foundryId, promotionId, userId)
    period: Specifies the period for which the metric is being requested (e.g., 2021, 2021-01)
  Responses:
    HTTP 200: Successful response
    HTTP 403: Operation not permitted
    HTTP 404: Metrics not found
    HTTP 500: Internal server error
  */
  function getMetricsAnalytics (scope, metricType, entityId, period) {
    return new Promise(function (resolve, reject) {
      try {
        if (!scope) {
          throw new Error('scope: Missing parameter')
        }
        if (scope && !(typeof scope === 'string')) {
          throw new Error('scope: Wrong type: Got "' + (typeof scope) + '", but expected: "string"')
        }
        if (!metricType) {
          throw new Error('metricType: Missing parameter')
        }
        if (metricType && !(typeof metricType === 'string')) {
          throw new Error('metricType: Wrong type: Got "' + (typeof metricType) + '", but expected: "string"')
        }
        if (!entityId) {
          throw new Error('entityId: Missing parameter')
        }
        if (entityId && !(typeof entityId === 'string')) {
          throw new Error('entityId: Wrong type: Got "' + (typeof entityId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['scope'] = scope
      parameters['metricType'] = metricType
      parameters['entityId'] = entityId
      parameters['period'] = period
      var path = '/analytics/metrics'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['logBannedWords'] = logBannedWordsAnalytics
  ret['getMetrics'] = getMetricsAnalytics
  return ret
})()

module.exports = Analytics
